import { render, staticRenderFns } from "./WorkerList976.vue?vue&type=template&id=2b1ad42a&scoped=true"
import script from "./WorkerList976.vue?vue&type=script&lang=js"
export * from "./WorkerList976.vue?vue&type=script&lang=js"
import style0 from "./WorkerList976.vue?vue&type=style&index=0&id=2b1ad42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ad42a",
  null
  
)

export default component.exports